import { useTranslation } from 'react-i18next';

import * as Yup from 'yup';

export interface SendEmailFormValues {
	email: string;
}

const schema = (): Yup.ObjectSchema<SendEmailFormValues> => {
	const { t } = useTranslation();

	return Yup.object({
		email: Yup.string()
			.email(t('validationMessages.login.invalidEmail'))
			.required(t('validationMessages.mandatory')),
	});
};

export default schema;
